<template>
    <q-page class=" q-pa-lg ">
        <q-dialog v-model="dialogNuevo" persistent transition-show="scale" transition-hide="scale">
            <q-card style="max-width: 800px;">
                 <q-card-section>
                    <q-toolbar>
                        <q-toolbar-title>
                            {{ $t('centroCostos.list.title') }}
                        </q-toolbar-title>
                        <q-btn dense round color="green" icon="mdi-content-save" class="q-mr-sm" @click="postCc()">
                            <q-tooltip>
                                {{ $t('buttons.save') }}
                            </q-tooltip>
                        </q-btn>
                        <q-btn round color="red" icon="mdi-close" dense v-close-popup>
                            <q-tooltip>
                                {{ $t('buttons.close') }}
                            </q-tooltip>
                        </q-btn>
                    </q-toolbar>
                    <q-separator class="full-width" color="primary" inset size="4px" />
                </q-card-section>
                <q-card-section>
                    <div class="row q-col-gutter-sm">
                        <div class="col-12 ">
                            <q-input v-model="centro.clave" dense filled :label="$t('centroCostos.list.key')" />
                        </div>
                        <div class="col-12 ">
                            <q-input v-model="centro.descripcion" dense filled :label="$t('centroCostos.list.description')" />
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogMetas" persistent transition-show="scale" transition-hide="scale">
            <q-card style="max-width: 800px;">
                 <q-card-section>
                    <q-toolbar>
                        <q-toolbar-title>
                            {{ $t('centroCostos.list.goals') }}
                        </q-toolbar-title>
                        <q-btn dense round color="green" icon="mdi-content-save" class="q-mr-sm" @click="postCc()">
                            <q-tooltip>
                                {{ $t('buttons.save') }}
                            </q-tooltip>
                        </q-btn>
                        <q-btn round color="red" icon="mdi-close" dense v-close-popup>
                            <q-tooltip>
                                {{ $t('buttons.close') }}
                            </q-tooltip>
                        </q-btn>
                    </q-toolbar>
                    <q-separator class="full-width" color="primary" inset size="4px" />
                </q-card-section>
                <q-card-section>
                    <div class="row q-col-gutter-sm">
                        <div class="col-12 ">
                            <q-input v-model="metaCentro.metaVentas" dense filled :label="$t('centroCostos.list.metaSales')" />
                        </div>
                        <div class="col-12 ">
                            <q-input v-model="metaCentro.topeGastos" dense filled :label="$t('centroCostos.list.expenseCap')" />
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-table class="shadow-0 header-tabla" :data="itemsCc" :pagination="initialPagination" :columns="columns" row-key="_id" :filter="filter">
            <template v-slot:loading>
                <q-inner-loading showing color="primary" />
            </template>
            <template v-slot:top>
                <div class="row q-col-gutter-sm q-mb-lg full-width">
                    <div class="col-12 col-md-4">
                        <div class=" text-h5">{{ $t('centroCostos.list.title') }}</div>
                    </div>
                    <div class="col-12 col-md-2">
                        <q-select dense bottom-slots filled v-model="añoCentroSelect" :options="itemsYears"
                            :label="$t('centroCostos.list.year')">
                        </q-select>
                    </div>
                    <div class="col-12 col-md-2">
                        <q-select dense bottom-slots filled v-model="añoCentroSelect" :options="itemsMes"
                            :label="$t('centroCostos.list.month')">
                        </q-select>
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input filled dense v-model="filter" debounce="300" :placeholder="$t('table.filter')">
                            <template v-slot:append>
                                <q-icon name="search" />
                            </template>
                            <template v-slot:after>
                                <q-btn flat round color="primary" icon="mdi-notebook-plus" @click="nueCc()">
                                    <q-tooltip>
                                        {{ $t('centroCostos.list.new') }}
                                    </q-tooltip>
                                </q-btn>
                            </template>
                        </q-input>
                    </div>
                </div>
            </template>
            <template v-slot:body="props">
                <q-tr :props="props">
                    <q-td auto-width key="acciones">
                        <q-btn flat round color="primary" icon="mdi-notebook-plus" @click="OpenMetas(props.row)">
                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                content-style="font-size: 14px">
                                {{ $t('centroCostos.list.goalsTooltip') }}
                            </q-tooltip>
                        </q-btn>
                        <q-btn size="md" color="red-10" rounded flat dense
                            icon="mdi-trash-can" @click="OpenDialogConfirm(props.row)">
                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                content-style="font-size: 14px">{{ $t('centroCostos.list.deleteTooltip') }}</q-tooltip>
                        </q-btn>
                    </q-td>
                    <q-td key="clave" :props="props">{{ props.row.clave }}</q-td>
                    <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                </q-tr>
            </template>
        </q-table>
    </q-page>
</template>
<script>
import axios from 'axios'
import * as XLSX from 'xlsx';
import { QSpinnerCube } from 'quasar'

export default {
    components: { 
    },
    data() {
        return {
            dialogNuevo: false,
            itemsCc: [],
            columns: [
                { name: 'acciones', align: 'center', label: this.$t('centroCostos.list.actions'), field: 'acciones', sortable: true },
                { name: 'clave', align: 'left', label: this.$t('centroCostos.list.key'), field: 'clave', sortable: true },
                { name: 'descripcion', align: 'left', label: this.$t('centroCostos.list.description'), field: 'descripcion', sortable: true, },
            ],
            filter: '',
            initialPagination: {
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            centro:{
                clave: null,
                descripcion: "",
            },

            //META CENTROS DE COSTOS
            itemsMes: [],
            dialogMetas: false,
            añoCentroSelect: null,
            metaCentro: {
                idCentroCostos: null,
                anio: null,
                mes: null,
                metaVentas: null,
                topeGastos: null,
            }
        }
    },
    computed: {
        token() {
            return this.$store.state.usuario;
        },

        itemsYears(){
            let lista= [];
            let añoActual = new Date().getFullYear();
            for(let i= 0; i<6; i++){
                console.log(i)
                lista.push(añoActual - i)
            }
            console.log(lista)
            return lista;
        },
    },

    created() {
        this.getCc()
    },

    methods: {        
        nueCc(){
            this.dialogNuevo = true;
        },

        async postCc(){
            const centroCostos = this.centro;
            if(!centroCostos.descripcion){
                this.$q.notify({ type: 'negative', message: this.$t('centroCostos.list.enterDescription'), color: 'red' })
                return;
            }
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: this.$t('centroCostos.list.saving'), messageColor: 'white' })
            try {
                let response = await axios.post('CentrosCostos/PostCentroCostosAsync/erp_' + this.token.rfc, centroCostos)

                this.$q.loading.hide()
                this.$q.notify({ type: 'positive', message: this.$t('centroCostos.list.savedSuccess') })
                this.dialogNuevo = false
                await this.getCc();
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: this.$t('centroCostos.list.errorSave'), color: 'red' })
            }
        },

        async getCc(){
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: this.$t('centroCostos.common.wait'), messageColor: 'white' })
            try {
                const response = await axios.get('CentrosCostos/GetCentroCostosAsync/erp_' + this.token.rfc)
                this.itemsCc = response.data;
                this.$q.loading.hide();
                console.log(response.data)
                this.dialogNuevo = false
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: this.$t('centroCostos.common.errorFetch'), color: 'red' })
            }
        },

        OpenDialogConfirm(){

        },

        //METAS
        OpenMetas(item){
            console.log(item)
            this.dialogMetas = true;
        },
    }
}
</script>

<style></style>